import { apiWrapper } from "@/services/api";

export const deleteUser = async () => {
  try {
    await apiWrapper("DELETE", `users-me`, {}, false, null, "Migrated");
  } catch (err) {
    console.log("ERROR!!! deleteUser");
    throw err;
  }
};
